import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class IntroBars extends AbstractChart {
    protected allChartOptions(): Options {
        const dataOptions = $(this.target).data('options') as Options | undefined;
        const maxY = (dataOptions as any)?.yAxis?.[0]?.max || (dataOptions as any)?.yAxis?.max || 52;
        const midY = Math.round(maxY / 2);

        const options: Options = {
            chart: {
                type: 'column',
                height: 400,
                width: 800,
                spacingLeft: 80,
                spacingRight: 160,
                marginTop: 40,
                // Give extra space for larger/rotated bottom labels so they don't get clipped
                marginBottom: 130,
                plotBorderWidth: 2,
                plotBorderColor: '#333',
                style: {
                    fontFamily: 'Arial, sans-serif'
                }
            },
            title: {text: undefined},
            xAxis: ({
                labels: {
                    useHTML: false,
                    // Larger font for category labels at the bottom
                    style: {fontSize: '14px', whiteSpace: 'nowrap'},
                    // Do not stagger or wrap labels; rotate instead so they never break to a new line
                    staggerLines: 1,
                    // Force a readable rotation so long labels don't wrap
                    rotation: -30,
                }
            } as any),
            yAxis: [
                {
                    min: 0,
                    max: maxY,
                    tickPositions: [0, midY, maxY],
                    title: {text: undefined},
                    gridLineWidth: 0,
                    labels: {style: {fontSize: '12px'}},
                    plotLines: [
                        {value: midY, color: '#333', width: 2, zIndex: 1},
                        {value: maxY, color: '#333', width: 2, zIndex: 1}
                    ]
                },
                {
                    opposite: true,
                    linkedTo: 0,
                    min: 0,
                    max: maxY,
                    tickPositions: [0, midY, maxY],
                    title: {text: undefined},
                    gridLineWidth: 0,
                    labels: {style: {fontSize: '12px'}}
                }
            ],
            legend: {enabled: false},
            tooltip: {enabled: false},
            plotOptions: {
                series: {
                    animation: false,
                    borderWidth: 0
                },
                column: {
                    // Match Responses chart column styling
                    color: '#f5b900',
                    borderColor: '#e5e5e5',
                    pointPadding: 0,
                    groupPadding: 0.01,
                    pointWidth: 60,
                    maxPointWidth: 70,
                    dataLabels: {
                        enabled: true,
                        // Remove any white outline/drop shadow around the numbers
                        style: {
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#000',
                            textOutline: 'none',
                            textShadow: 'none'
                        },
                        formatter: function () {
                            return (this.y as number).toString();
                        },
                        inside: true,
                        align: 'center',
                        verticalAlign: 'top',
                        y: 8,
                    },
                    events: {
                        afterAnimate: function () {
                            const series = this;
                            series.points.forEach(function (point: any) {
                                if (point.dataLabel) {
                                    const labelY = point.dataLabel.y;
                                    const columnTop = point.shapeArgs.y;

                                    // If label is above the column (outside)
                                    if (labelY < columnTop) {
                                        // Add spacing by moving label up more
                                        point.dataLabel.attr({
                                            y: labelY - 10
                                        });
                                    }
                                }
                            });
                        }
                    }

                }
            },
            credits: {enabled: false},
            exporting: {enabled: false}
        };

        // Merge provided options last so caller can override defaults
        return super.mergeOptions(super.allChartOptions(), options, dataOptions || {});
    }
}

export default function () {
    registerPlugin(IntroBars);
}
